/* eslint-disable max-lines-per-function */
import { store } from "jiffy-store";
import { camelize } from "common/utils/helpers/cases";
import productPage from "./product-page";

const getCartSubtotal = form => {
  let cartSum = store.get(state => {
    const { originalCartTotal, activeCart } = state.pdp;
    return activeCart ? Number(activeCart.amount) : originalCartTotal;
  });
  const formId = form.getAttribute("id");
  const storeForm = store.get(state => state.pdp[camelize(formId)]);

  const tieredPrices = productPage.variantPrintAreaPrice
    ? productPage.variantPrintAreaPrice
    : productPage.variantPricesData;

  Object.keys(storeForm).forEach(variantId => {
    const inputValue = storeForm[variantId].input.value;

    if (inputValue !== "") {
      const variantQuantity = parseInt(inputValue, 10);
      if (variantQuantity > 0) {
        cartSum += variantQuantity * tieredPrices[variantId][0];
      }
    }
  });

  return cartSum;
};

const getVariantCount = (form, variantId) => {
  const formId = form.getAttribute("id");
  const variantQuantityField = store.get(state => state.pdp[camelize(formId)][variantId]);

  let inputValue = "";
  let count = 0;

  if (variantQuantityField) {
    inputValue = variantQuantityField.input.value;
  }

  if (inputValue !== "") {
    count = parseInt(inputValue, 10);
  }

  return count;
};

const getSumPriority = cartSum => {
  let i;
  let len;
  let price;
  let priority;
  if (!productPage.variantPricesData) return 0;
  const firstVariant = productPage.variantPricesData[Object.keys(productPage.variantPricesData)[0]];
  const priceBook = Object.keys(firstVariant);
  priority = 0;

  for (i = 0, len = priceBook.length; i < len; i += 1) {
    price = priceBook[i];
    if (parseInt(price, 10) < cartSum) {
      priority = parseInt(price, 10);
    }
  }
  return priority;
};

const getCountPriority = (variantCount = 0, variantId = null) => {
  const currentVariantId = variantId || Object.keys(productPage.variantPricesCountData)[0];
  const variant = productPage.variantPricesCountData[currentVariantId];
  const countBook = Object.keys(variant)
    .sort((a, b) => a - b)
    .reverse();
  let minCount = countBook[countBook.length - 1];

  for (let i = 0; i < countBook.length; i += 1) {
    const count = parseInt(countBook[i], 10);

    if (variantCount >= count) {
      minCount = count;
      break;
    }
  }

  return minCount;
};

export const getPriority = (cartSum, count, variantId = null) => {
  if (productPage.variantPricesCountData) {
    return getCountPriority(count, variantId);
  }

  return getSumPriority(cartSum);
};

export const extractPriority = (form, variantId) => {
  const cartSum = productPage.variantPricesCountData ? 0 : getCartSubtotal(form);
  const countItems = getVariantCount(form, variantId);

  return getPriority(cartSum, countItems, variantId);
};
